import React from 'react';
import { Clock } from 'lucide-react';

const Navbar = ({ title = "Dashboard", admitted_patients, assigned_devices, discharged_patients, lastUpdated }) => {

  const formatIST = (timestamp) => {
    if (!timestamp) return 'N/A';
    return new Date(timestamp).toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  };

  return (
    <nav className="bg-white shadow-md rounded-lg md:my-6 md:mx-4">
      <div className="px-6 py-4 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-green-600 font-semibold flex items-center">
            <span className="w-2 h-2 bg-green-600 rounded-full mr-2"></span> <span className="">Active Patients - <span className="font-bold">{admitted_patients}</span></span>
          </div>
          <div className="text-yellow-500 font-semibold flex items-center">
            <span className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span> <span className="">Disconnected Devices - <span className="font-bold">{assigned_devices}</span></span>
          </div>
          <div className="text-gray-500 font-semibold flex items-center">
            <span className="w-2 h-2 bg-gray-500 rounded-full mr-2"></span> <span className="">Discharged Today - <span className="font-bold">{discharged_patients}</span></span>
          </div>
        </div>
        <div className="flex items-center">
          <span className="md:hidden flex items-center text-sm text-gray-500 mr-3">
            <Clock className="h-4 w-4 mr-1" />
            <span className="font-medium">{formatIST(lastUpdated)}</span>
          </span>
          <span className="hidden md:flex items-center md:text-sm text-xs font-bold text-gray-500">
            <Clock className="h-4 w-4 mr-1" />
            Last Updated: <span className="ml-1 font-medium">{formatIST(lastUpdated)}</span>
          </span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;